const toPrice = (price) => {
  if (price === null || price === undefined) { return }
  if (price.toString() === '0') { return '0' }
  let num = price.toString().split('.');
  num[0] = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return num.join('.');
}

export default toPrice